// import { colours } from "orcs-design-system";
// TODO: Remove duplication with similar named file in non-shared components (move to orcs?)

import PropTypes from "prop-types";
import styled, { keyframes } from "styled-components";

import { lineGradient } from "src/components/Placeholder/placeholderGradients";

/* Infinite Rotation */
const COLOR_CHANGE = keyframes`
0% {
  background-position: -468px 0;
}
100% {
  background-position: 468px 0;
}
`;

const FADE_IN = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

type LineStyleProps = {
  width?: number;
  height?: number;
  delay?: string;
  mb?: number;
};

// use for placeholder lines
// TODO: Better method than putting in pixel value for dimensions?
export const Line = styled.div<LineStyleProps>`
  border-radius: 8px;
  animation-delay: 0.2s;
  background: ${({ theme }) => lineGradient(theme)};
  opacity: 0;
  animation:
    ${COLOR_CHANGE} 10s linear both infinite,
    ${FADE_IN} 300ms ease-in forwards ${({ delay = "500ms" }) => delay};
  height: ${({ height = 24 }) => `${height}px`};
  width: ${({ width = 200 }) => `${width}px`};
  margin-bottom: ${({ mb }) => (mb ? `${mb}px` : "0px")};
`;

Line.propTypes = {
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  delay: PropTypes.string,
};
Line.defaultProps = {
  width: 200,
  height: 24,
  delay: "500ms",
};
